AnalyticsRunner = require 'analytics/runner.coffee'
runner = new AnalyticsRunner

module.exports = runner
